import { render, staticRenderFns } from "./SapUpdateFailList.vue?vue&type=template&id=0bff57a5"
import script from "./SapUpdateFailList.vue?vue&type=script&lang=js"
export * from "./SapUpdateFailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports